import { useTheme } from '@emotion/react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { stripDuplicates } from 'lib/array';
import { isBlackFridayLanding } from 'lib/utils';

import { useTopbar } from 'providers/TopbarProvider';

import CategoriesDropdownItem from './CategoriesDropdownItem';

const BlackFridayDropdownItem = dynamic(
  () => import('./BlackFridayDropdownItem'),
  { ssr: false }
);

const getCategoryGroupNamesAsGroupSort = (categories) =>
  stripDuplicates(categories?.map((category) => [category.groupName]).flat());

const CategoryGroupNamesDropdownList = ({
  activeCategory,
  categories,
  setActiveCategory,
}) => {
  const theme = useTheme();
  const { highlightedLandings, featuredLanding } = useTopbar();

  return (
    <div>
      {getCategoryGroupNamesAsGroupSort(categories).map((categoryGroupName) => (
        <CategoriesDropdownItem
          data-test-selector="categories-dropdown-item"
          key={categoryGroupName}
          borderBottom="1px solid"
          px={4}
          py={3}
          borderColor={theme.app.dropdown.border}
          bg={
            categoryGroupName === activeCategory
              ? theme.app.dropdown.itemHover
              : null
          }
          onMouseEnter={() => setActiveCategory(categoryGroupName)}
          full
        >
          <Text whiteSpace="nowrap" mr={6} bold>
            {categoryGroupName}
          </Text>
          <Icon name="arrow-forward" size="size1" />
        </CategoriesDropdownItem>
      ))}
      {highlightedLandings.length > 0 &&
        isBlackFridayLanding(featuredLanding) && (
          <BlackFridayDropdownItem
            activeCategory={activeCategory}
            setActiveCategory={setActiveCategory}
          />
        )}
    </div>
  );
};

CategoryGroupNamesDropdownList.displayName = 'CategoryGroupNamesDropdownList';

CategoryGroupNamesDropdownList.defaultProps = {
  activeCategory: null,
};

CategoryGroupNamesDropdownList.propTypes = {
  activeCategory: PropTypes.string,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number,
      categoryName: PropTypes.string.isRequired,
      categoryUrl: PropTypes.string.isRequired,
      groupId: PropTypes.number.isRequired,
      groupName: PropTypes.string.isRequired,
      subcategories: PropTypes.array.isRequired,
    }).isRequired
  ),
  setActiveCategory: PropTypes.func.isRequired,
};

export default CategoryGroupNamesDropdownList;
